export const build = { date:"2026-06-12.1134", stage:"alpha" }
